import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Home as HomeIcon, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Seo from '../components/Seo';

const NotFound = () => (
  <div className="min-h-[80vh] bg-gradient-to-b from-white to-slate-50 grid place-items-center px-4">
    <Seo title="404 - Page Not Found | Learndunia" description="The page you are looking for does not exist." />
    <div className="text-center max-w-lg">
      <div className="w-16 h-16 mx-auto rounded-2xl bg-teal-600 grid place-items-center text-white shadow-md">
        <GraduationCap className="w-8 h-8" />
      </div>
      <div className="mt-6 text-7xl md:text-8xl font-extrabold gradient-text" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>404</div>
      <h1 className="mt-3 text-2xl md:text-3xl font-bold text-slate-900" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Page not found</h1>
      <p className="text-slate-600 mt-2">The page you are looking for might have been removed, renamed or is temporarily unavailable.</p>
      <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link to="/"><Button className="bg-teal-600 hover:bg-teal-700 text-white"><HomeIcon className="w-4 h-4 mr-1.5" /> Back to Home</Button></Link>
        <Link to="/colleges"><Button variant="outline"><Search className="w-4 h-4 mr-1.5" /> Browse Colleges</Button></Link>
      </div>
    </div>
  </div>
);

export default NotFound;
